import React, { Fragment } from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postWoodlandForms } from "../../redux/actions/woodlandActions";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";

const Machinery = ({ appData, postWoodlandFormsFunc }) => {
  const initialState = {
    blurb1: {
      htmlObj: <HorizontalLine text={"Section 4 – Machinery/Equipment Use"} />,
    },
    mach1: {
      type: "singlecheckbox",
      title:
        "I have shown my licence and that I am competent on the machinery/equipment I will be required to use.",
      mandatory: true,
    },
    mach2: {
      type: "singlecheckbox",
      title:
        "I understand that only trained personnel are permitted to use Mechanical Handling Equipment (MHE), vehicles and machinery as instructed by the team leader.",
      mandatory: true,
    },
    mach3: {
      type: "singlecheckbox",
      title:
        "I understand that there is MHE operating within the warehouse and will take care when moving around.",
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const woodland = appData.woodlandGroupOnboarding;
  const submitted = woodland && woodland.machinery;

  const redirectBack = () => {
    history.push("/profile/edit/woodland-group-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postWoodlandFormsFunc("machinery", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Machinery/Equipment Use"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"woodlandBranch"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

Machinery.propTypes = {
  appData: any,
  postWoodlandFormsFunc: func,
};

const mapDispatchToProps = {
  postWoodlandFormsFunc: postWoodlandForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(Machinery);
